import { DesktopOnlyFix, MobileOnly, TabletOnly } from 'common/components';
import { useClassName } from 'common/hooks';
import React from 'react';
import './intro.less';

export const Intro = ({
  title,
  description,
  pet,
  waves,
  mainColor,
  tertiaryColor,
}) => {
  const className = useClassName('Intro');
  return (
    <div className={className('container')}>
      <div
        className={className('container__main')}
        style={{
          background: mainColor,
        }}>
        <div className={className('container__inner')}>
          <div className={className('container__inner__header')}>
            <div
              className={className('container__inner__header__background')}
              style={{
                opacity: 0.7,
                background: `linear-gradient(to bottom, transparent, ${mainColor})`,
              }}></div>
            <h3 className={className('container__inner__header__title')}>
              {title}
            </h3>
            <p className={className('container__inner__header__description')}>
              {description}
            </p>
          </div>
          <DesktopOnlyFix
            className={className('container__inner__pet', 'desktop')}>
            <img src={pet.desktop.assetUrl} alt={pet.desktop.assetAlt} />
          </DesktopOnlyFix>
          <TabletOnly className={className('container__inner__pet', 'tablet')}>
            <img src={pet.tablet.assetUrl} alt={pet.tablet.assetAlt} />
          </TabletOnly>
          <MobileOnly className={className('container__inner__pet', 'mobile')}>
            <img src={pet.mobile.assetUrl} alt={pet.mobile.assetAlt} />
          </MobileOnly>
        </div>
      </div>
      <div
        className={className('container__waves')}
        style={{
          background: tertiaryColor,
        }}>
        <img src={waves.desktop.assetUrl} alt={waves.desktop.assetAlt} />
      </div>
    </div>
  );
};
